'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getListType = function getListType(nodes) {
  var taxonomyType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'spot';

  var targetTaxonomy = nodes.find(function (node) {
    return node.type === taxonomyType;
  });

  if (!targetTaxonomy) {
    return 'geonames';
  }
  return taxonomyType + 's';
};

exports.default = getListType;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/utils/getListType.js
// module id = 343
// module chunks = 0